/**
 * @file success-state.icon.tsx
 * @description Компонент для отображения иконки статуса выполненной задачи.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-03
 * @dependencies [classnames]
 */

import cn from 'classnames';
import { IIconProps } from '@src/types';

export const SuccessTaskStateIcon = ({ className, size = '1.6937vmin', color = '#4B6178', onClick, ...props }: IIconProps) => {
    return (
        <div className={cn(className, { 'cursor-pointer': onClick })} onClick={onClick} style={{ color }} {...props}>
            <svg width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM1.2 8C1.2 11.7555 4.24446 14.8 8 14.8C11.7555 14.8 14.8 11.7555 14.8 8C14.8 4.24446 11.7555 1.2 8 1.2C4.24446 1.2 1.2 4.24446 1.2 8Z"
                    fill="currentcolor"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.59 5.43937C11.6989 5.54834 11.7601 5.69611 11.7601 5.85019C11.7601 6.00428 11.6989 6.15205 11.59 6.26102L7.2346 10.6164C7.17705 10.674 7.10871 10.7197 7.0335 10.7508C6.95829 10.782 6.87768 10.798 6.79627 10.798C6.71487 10.798 6.63426 10.782 6.55905 10.7508C6.48384 10.7197 6.4155 10.674 6.35794 10.6164L4.194 8.45286C4.1385 8.39925 4.09423 8.33513 4.06378 8.26424C4.03332 8.19335 4.01729 8.1171 4.01662 8.03994C4.01595 7.96278 4.03066 7.88627 4.05987 7.81486C4.08909 7.74344 4.13224 7.67856 4.1868 7.624C4.24136 7.56945 4.30623 7.5263 4.37765 7.49708C4.44906 7.46786 4.52558 7.45316 4.60273 7.45383C4.67989 7.4545 4.75614 7.47053 4.82703 7.50099C4.89793 7.53144 4.96204 7.57571 5.01565 7.63121L6.79608 9.41164L10.768 5.43937C10.8219 5.38537 10.886 5.34254 10.9565 5.31331C11.027 5.28409 11.1026 5.26904 11.179 5.26904C11.2553 5.26904 11.3309 5.28409 11.4014 5.31331C11.472 5.34254 11.536 5.38537 11.59 5.43937Z"
                    fill="currentcolor"
                />
            </svg>
        </div>
    );
};
